import React from 'react'
import { CustomTooltipProps, DonutChart, Text } from '@tremor/react'

import { DONUT_CHART_MIN_VALUE } from 'consts/charts'

const montserratStyle = { fontFamily: 'Montserrat, sans-serif', color: '#1E1E1E' }

export interface DonutTagChartProps {
  // eslint-disable-next-line react/require-default-props
  title?: string
  // eslint-disable-next-line @typescript-eslint/member-delimiter-style
  data: Array<{ name: string; value: number; color: string }>
  className?: string
  style?: React.CSSProperties
  chartTitle?: string
  customTooltip?: React.ComponentType<CustomTooltipProps>
}

export const DonutTagChart: React.FC<DonutTagChartProps> = ({
  title,
  data,
  className = '',
  style = {},
  chartTitle,
  customTooltip,
}) => {
  return (
    <div className={`p-6 bg-white ${className}`} style={style}>
      <Text className="text-lg font-bold mb-4" style={montserratStyle}>
        {title}
      </Text>
      <div className="flex flex-row items-center justify-between" style={{ minHeight: 340 }}>
        <div
          className="flex items-center justify-center w-full h-60"
          style={{ flexBasis: '60%', maxWidth: '60%' }}
        >
          <div className="w-full h-full flex items-center justify-center">
            <DonutChart
              data={data}
              category="value"
              index="name"
              colors={data.map(d => d.color)}
              showLabel={false}
              noDataText="No hay datos disponibles para mostrar en este momento."
              {...(customTooltip && { customTooltip })}
            />
          </div>
        </div>
        <div
          className="flex flex-col gap-4 ml-6 w-full justify-center"
          style={{ flexBasis: '40%', maxWidth: '40%' }}
        >
          {chartTitle && (
            <div className="text-base font-bold mb-2" style={montserratStyle}>
              {chartTitle}
            </div>
          )}
          {data.map(item => (
            <div key={item.name} className="flex items-center gap-2">
              <span
                className={`bg-${item.color}-500`}
                style={{
                  width: 8,
                  height: 32,
                  borderRadius: 4,
                  display: 'inline-block',
                }}
              />
              <div>
                <span className="text-xl font-extrabold" style={montserratStyle}>
                  {item.value <= DONUT_CHART_MIN_VALUE ? 0 : item.value}%
                </span>
                <div className="text-base" style={montserratStyle}>
                  {item.name}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

DonutTagChart.defaultProps = {
  className: '',
  style: {},
  chartTitle: undefined,
  customTooltip: undefined,
}

export default DonutTagChart
